require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./borgesian-sentence.json") })
        }
      }, "path---borgesian-sentence");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---borgesian-sentence!./.cache/json/borgesian-sentence.json
// module id = 834
// module chunks = 231608221292675